import appConstants from '../constants';
import fetchService from './fetchService';

const SERVICE_URL = `${appConstants.SERVICE_BASE_URL}${appConstants.SERVICE_REQUEST_GET_COMBINED_SUGGESTIONS_URL}`;

function getGroupValueData(data, selectedGroupValue, foundGroupValues) {
  return foundGroupValues.includes(selectedGroupValue) ?
    data.filter(dataObject => dataObject[appConstants.KEY_GROUPVALUE] === selectedGroupValue) :
    []
}

function getPartnerIntegratorLevelSuggestions(partnerLevelData) {
  if(!!partnerLevelData && !!partnerLevelData.length) {
    return {
      groupName: appConstants.LABEL_INTEGRATOR_LEVELS,
      groupSuggestions: partnerLevelData[0][appConstants.KEY_DOCLIST]
        .filter(
          partnerLevelObject => partnerLevelObject[appConstants.KEY_PARENT_CATEGORY_DESC] === appConstants.VALUE_INTEGRATOR
        )
        .map(
        (partnerLevelObject) => {
          return Object.fromEntries(
            new Map([
              [appConstants.KEY_NAME, `${partnerLevelObject[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_INTEGRATOR}`],
              [appConstants.KEY_CODE, `${partnerLevelObject[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_INTEGRATOR}`],
              [appConstants.KEY_IS_SELECTED, true],
              [appConstants.KEY_IS_DISABLED, false],
              [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_LEVEL],
              [appConstants.KEY_SUBTYPE, appConstants.VALUE_INTEGRATOR],
              [appConstants.KEY_ORIGINAL_DATA, { ...partnerLevelObject }]
            ])
          )
        }
      )
    }
  }
  else {
    return { groupName: appConstants.LABEL_INTEGRATOR_LEVELS, groupSuggestions: [] }
  }
}
function getPartnerProviderLevelSuggestions(partnerLevelData) {
  if(!!partnerLevelData && !!partnerLevelData.length) {
    return {
      groupName: appConstants.LABEL_PROVIDER_LEVELS,
      groupSuggestions: partnerLevelData[0][appConstants.KEY_DOCLIST]
        .filter(
          partnerLevelObject => partnerLevelObject[appConstants.KEY_PARENT_CATEGORY_DESC] === appConstants.VALUE_PROVIDER
        )
        .map(
        (partnerLevelObject) => {
          return Object.fromEntries(
            new Map([
              [appConstants.KEY_NAME, `${partnerLevelObject[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_PROVIDER}`],
              [appConstants.KEY_CODE, `${partnerLevelObject[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_PROVIDER}`],
              [appConstants.KEY_IS_SELECTED, true],
              [appConstants.KEY_IS_DISABLED, false],
              [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_LEVEL],
              [appConstants.KEY_SUBTYPE, appConstants.VALUE_PROVIDER],
              [appConstants.KEY_ORIGINAL_DATA, { ...partnerLevelObject }]
            ])
          )
        }
      )
    }
  }
  else {
    return { groupName: appConstants.LABEL_PROVIDER_LEVELS, groupSuggestions: [] }
  }
}
function getPartnerDeveloperLevelSuggestions(partnerLevelData) {
  if(!!partnerLevelData && !!partnerLevelData.length) {
    return {
      groupName: appConstants.LABEL_DEVELOPER_LEVELS,
      groupSuggestions: partnerLevelData[0][appConstants.KEY_DOCLIST]
        .filter(
          partnerLevelObject => partnerLevelObject[appConstants.KEY_PARENT_CATEGORY_DESC] === appConstants.VALUE_DEVELOPER
        )
        .map(
          (partnerLevelObject) => {
            return Object.fromEntries(
              new Map([
                [appConstants.KEY_NAME, `${partnerLevelObject[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_DEVELOPER}`],
                [appConstants.KEY_CODE, `${partnerLevelObject[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_DEVELOPER}`],
                [appConstants.KEY_IS_SELECTED, true],
                [appConstants.KEY_IS_DISABLED, false],
                [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_LEVEL],
                [appConstants.KEY_SUBTYPE, appConstants.VALUE_DEVELOPER],
                [appConstants.KEY_ORIGINAL_DATA, { ...partnerLevelObject }]
              ])
            )
          }
        )
    }
  }
  else {
    return { groupName: appConstants.LABEL_DEVELOPER_LEVELS, groupSuggestions: [] }
  }
}
function getPartnerAdvisorLevelSuggestions(partnerLevelData) {
  if(!!partnerLevelData && !!partnerLevelData.length) {
    return {
      groupName: appConstants.LABEL_ADVISOR_LEVELS,
      groupSuggestions: partnerLevelData[0][appConstants.KEY_DOCLIST]
        .filter(
          partnerLevelObject => partnerLevelObject[appConstants.KEY_PARENT_CATEGORY_DESC] === appConstants.VALUE_ADVISOR
        )
        .map(
          (partnerLevelObject) => {
            return Object.fromEntries(
              new Map([
                [appConstants.KEY_NAME, `${partnerLevelObject[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_ADVISOR}`],
                [appConstants.KEY_CODE, `${partnerLevelObject[appConstants.KEY_KEYWORD_DISPLAY_NAME].trim()} ${appConstants.VALUE_ADVISOR}`],
                [appConstants.KEY_IS_SELECTED, true],
                [appConstants.KEY_IS_DISABLED, false],
                [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_LEVEL],
                [appConstants.KEY_SUBTYPE, appConstants.VALUE_ADVISOR],
                [appConstants.KEY_ORIGINAL_DATA, { ...partnerLevelObject }]
              ])
            )
          }
        )
    }
  }
  else {
    return { groupName: appConstants.LABEL_ADVISOR_LEVELS, groupSuggestions: [] }
  }
}
function getPartnerIntegratorSpecializationSuggestions(partnerSpecializationData) {
  if(!!partnerSpecializationData && !!partnerSpecializationData.length) {
    return {
      groupName: appConstants.LABEL_INTEGRATOR_SPECIALIZATIONS,
      groupSuggestions: partnerSpecializationData[0][appConstants.KEY_DOCLIST]
        .filter(
          partnerSpecializationObject => partnerSpecializationObject[appConstants.KEY_PARENT_CATEGORY_DESC] === appConstants.VALUE_INTEGRATOR
        )
        .map(
        (partnerSpecializationObject) => {
          return Object.fromEntries(
            new Map([
              [appConstants.KEY_NAME, partnerSpecializationObject[appConstants.KEY_KEYWORD_DISPLAY_NAME]],
              [appConstants.KEY_CODE, partnerSpecializationObject[appConstants.KEY_KEYWORD_DISPLAY_NAME]],
              [appConstants.KEY_IS_SELECTED, true],
              [appConstants.KEY_IS_DISABLED, false],
              [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_SPECIALIZATION],
              [appConstants.KEY_SUBTYPE, appConstants.VALUE_INTEGRATOR],
              [appConstants.KEY_ORIGINAL_DATA, { ...partnerSpecializationObject }]
            ])
          )
        }
      )
    }
  }
  else {
    return { groupName: appConstants.LABEL_INTEGRATOR_SPECIALIZATIONS, groupSuggestions: [] }
  }
}
function getPartnerProviderCiscoPoweredServiceSuggestions(partnerProviderCiscoPoweredServiceData) {
  if(!!partnerProviderCiscoPoweredServiceData && !!partnerProviderCiscoPoweredServiceData.length) {
    return {
      groupName: appConstants.LABEL_CISCO_POWERED_SERVICES,
      groupSuggestions: partnerProviderCiscoPoweredServiceData[0][appConstants.KEY_DOCLIST]
        .filter(
          partnerProviderCiscoPoweredServiceObject => partnerProviderCiscoPoweredServiceObject[appConstants.KEY_PARENT_CATEGORY_DESC] === appConstants.VALUE_PROVIDER
        )
        .map(
        (partnerProviderCiscoPoweredServiceObject) => {
          return Object.fromEntries(
            new Map([
              [appConstants.KEY_NAME, partnerProviderCiscoPoweredServiceObject[appConstants.KEY_KEYWORD_DISPLAY_NAME]],
              [appConstants.KEY_CODE, partnerProviderCiscoPoweredServiceObject[appConstants.KEY_KEYWORD_DISPLAY_NAME]],
              [appConstants.KEY_IS_SELECTED, true],
              [appConstants.KEY_IS_DISABLED, false],
              [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_SPECIALIZATION],
              [appConstants.KEY_SUBTYPE, appConstants.VALUE_PROVIDER],
              [appConstants.KEY_ORIGINAL_DATA, { ...partnerProviderCiscoPoweredServiceObject }]
            ])
          )
        }
      )
    }
  }
  else {
    return { groupName: appConstants.LABEL_CISCO_POWERED_SERVICES, groupSuggestions: [] }
  }
}
function getPartnerNameSuggestions(partnerNameData) {
  if(!!partnerNameData && !!partnerNameData.length) {
    return {
      groupName: appConstants.LABEL_PARTNER_NAMES,
      groupSuggestions: partnerNameData[0][appConstants.KEY_DOCLIST].map(
        (partnerNameObject) => {
          return Object.fromEntries(
            new Map([
              [appConstants.KEY_NAME, partnerNameObject[appConstants.KEY_KEYWORD_DISPLAY_NAME]],
              [appConstants.KEY_CODE, partnerNameObject[appConstants.KEY_KEYWORD_DISPLAY_NAME]],
              [appConstants.KEY_IS_SELECTED, true],
              [appConstants.KEY_IS_DISABLED, false],
              [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_NAME],
              [appConstants.KEY_SUBTYPE, appConstants.VALUE_PARTNER_NAME],
              [appConstants.KEY_ORIGINAL_DATA, {...partnerNameObject}]
            ])
          )
        }
      )
    }
  }
  else {
    return { groupName: appConstants.LABEL_PARTNER_NAMES, groupSuggestions: [] }
  }
}

function getSearchTermsAsPartnerNameSuggestion(searchTerms) {
  return {
    groupName: appConstants.LABEL_PARTNER_NAME_KEYWORD_S_,
    groupSuggestions: [
      Object.fromEntries(
          new Map([
            [appConstants.KEY_NAME, searchTerms],
            [appConstants.KEY_CODE, searchTerms],
            [appConstants.KEY_IS_SELECTED, true],
            [appConstants.KEY_IS_DISABLED, false],
            [appConstants.KEY_TYPE, appConstants.VALUE_PARTNER_NAME],
            [appConstants.KEY_SUBTYPE, appConstants.VALUE_PARTNER_NAME_KEYWORD],
            [appConstants.KEY_ORIGINAL_DATA, {...searchTerms}]
          ])
      )
    ]
  }
}

function processData(data, searchTerms) {
  let processedData = {
    partnerIntegratorLevelSuggestions: null,
    partnerProviderLevelSuggestions:  null,
    partnerDeveloperLevelSuggestions: null,
    partnerAdvisorLevelSuggestions: null,
    partnerIntegratorSpecializationSuggestions: null,
    partnerProviderCiscoPoweredServiceSuggestions: null,
    partnerNameSuggestions: null,
    searchedTermsAsPartnerNameSuggestion: null
  };

  if (!!data && !!data.length) {
    const foundGroupValues = data.map(dataObject => dataObject[appConstants.KEY_GROUPVALUE]);
    const partnerLevelData = getGroupValueData(data, appConstants.GROUPVALUE_PARTNER_LEVEL, foundGroupValues);
    const partnerSpecializationData = getGroupValueData(data, appConstants.GROUPVALUE_PARTNER_SPECIALIZATIONS, foundGroupValues);
    const partnerNameData = getGroupValueData(data, appConstants.GROUPVALUE_PARTNER_NAME, foundGroupValues);

    processedData = {
      partnerIntegratorLevelSuggestions: getPartnerIntegratorLevelSuggestions(partnerLevelData),
      partnerProviderLevelSuggestions: getPartnerProviderLevelSuggestions(partnerLevelData),
      partnerDeveloperLevelSuggestions: getPartnerDeveloperLevelSuggestions(partnerLevelData),
      partnerAdvisorLevelSuggestions: getPartnerAdvisorLevelSuggestions(partnerLevelData),
      partnerIntegratorSpecializationSuggestions: getPartnerIntegratorSpecializationSuggestions(partnerSpecializationData),
      partnerProviderCiscoPoweredServiceSuggestions: getPartnerProviderCiscoPoweredServiceSuggestions(partnerSpecializationData),
      partnerNameSuggestions: getPartnerNameSuggestions(partnerNameData),
      searchedTermsAsPartnerNameSuggestion: getSearchTermsAsPartnerNameSuggestion(searchTerms)
    };
  }
  return {
    hasError: false,
    errorMessage: null,
    ...processedData
  };
}

export default async function getSuggestions(debouncedSearchedTerms, selectedCountry) {
  let fetchedDataObject =
    await fetchService(
      'getSuggestions',
      SERVICE_URL,
      {
        ...appConstants.SERVICE_REQUEST_GET_COMBINED_SUGGESTIONS_CONFIG,
        body: JSON.stringify({
          SEARCH_PARAM: debouncedSearchedTerms,
          KEYWORD_IDS: `${selectedCountry[appConstants.KEY_ORIGINAL_DATA][appConstants.KEY_KEYWORD_ID]}`.trim()
        })
      }
    );

    return !fetchedDataObject.success ?
      {
        hasError: true,
        errorMessage: fetchedDataObject.statusMessage,
        partnerIntegratorLevelSuggestions: null,
        partnerProviderLevelSuggestions:  null,
        partnerDeveloperLevelSuggestions: null,
        partnerAdvisorLevelSuggestions: null,
        partnerIntegratorSpecializationSuggestions: null,
        partnerProviderCiscoPoweredServiceSuggestions: null,
        partnerNameSuggestions: null,
        searchedTermsAsPartnerNameSuggestion: null
      } :
      processData(fetchedDataObject.data, debouncedSearchedTerms);
}
